<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('/yandex-direct')">
            <i class="ksi ksi-yandex-direct"></i>
            <span>{{ $t('lang.menu.yandex_direct') }}</span>
        </a>
        <a :href="getLink('/rsya')">
            <i class="ksi ksi-rsya"></i>
            <span>{{ $t('lang.menu.rsya') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";

export default {
    name: "MenuSubmenuTopLinks",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_ADS_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
